export default {
    islogin: false,
    loading: true,
    token: null,
    authcheck: false,
    role: null,
    user: [],
    expense_type: [],
    active_expense_type: [],
    expense: [],
    broke: [],
    category: [],
    unit: [],
    company: [],
    customer: [],
    item: [],
    removeditem: [],
    today_invoice: [],
    company_invoice_item: [],
    stok: [],
    total_stock_price: 0,
    ledger_customer_id: 0,
    ledger_customer_name: "",
    ledger_customer_phone: "",
    ledger_customer_address: "",
    ledger_company_id: 0,
    ledger_company_name: "",
    ledger_company_phone: "",
    ledger_company_address: "",
    ledger_item_id: 0,
    ledger_item_code: "",
    ledger_item_name: "",
    ledger_item_unit_one: "",
    ledger_item_unit_many: "",
    ledger_item_unit_one_of_many: 0,
    most_sell_report: [],
    least_sell_report: [],
    category_sell_report: [],
    most_profitable_sell_report: [],
    summary_sell_report: 0,
    summary_sell_profit_report: 0,
    summary_expense_report: [],
    customer_loan_report: [],
    loan_in_report: [],
    summary_loan_in_report: 0,
    company_loan_report: [],
    loan_out_report: [],
    summary_loan_out_report: 0,
    most_broke_report: [],
    most_gift_report: [],
    summary_broke_report: 0,
    summary_gift_report: 0,
    summary_report_total_sell: 0,
    summary_report_total_profit: 0,
    summary_report_total_expense: 0,
    summary_report_total_gift: 0,
    summary_report_total_broke: 0,
    summary_report_total_stock_price: 0,
    summary_report_total_loan_in: 0,
    summary_report_total_loan_out: 0,
    summary_report_total_save: 0,
    profitdetail_array: [],
    company_report: [],
    returnbybarcode: [],
    return_item_company: [],
    summary_report_sell_array: [],
    ledger: [],
    mizania: [],
    mizania_date: "",
    mizania_customer_id: 0,
    mizania_customer_name: "",
    mizania_customer_phone: "",
    mizania_customer_address: "",
    mizania_company_id: 0,
    mizania_company_name: "",
    mizania_company_phone: "",
    mizania_company_address: "",
    mizania_form_date: "",
    mizania_form_table_type: "",
    mizania_form_ddata: [],
    dollar_price: 0,
    summary_report_damage_amount: 0,
    summary_report_return_item_company_qty: 0,
    summary_report_return_item_company_amount: 0,
    total_sell_qty: 0,
    total_sell_price: 0,
    total_return_qty: 0,
    total_return_price: 0,
    total_broke_qty: 0,
    total_broke_price: 0,
    item_sell_report_qty: 0,
    item_sell_report_price: 0,
}